import React, { Component } from 'react';
import CloseIcon from "@mui/icons-material/Close";
import { decodeJwt } from '../Pages/ApiCommonService';
import { Grid, TextField, Button, RadioGroup, FormControlLabel, Radio, Typography, MenuItem, Box, Divider, IconButton } from '@mui/material';
import { saveDataForIntroduceBrokerForm, fetchAlllogoData, saveDataForLogoData, fetchBrokerLogoById } from '../ApiSevices/ExdionAdminApi';

interface Props {
    onCancel: () => void;
    editData: any;
}

interface State {
    logoObj: any[];
    fileNames: any;
    loading: boolean;
    brokerFormData: any;
    logoPreview: any;
    logoPayload: any;
    BrokerId: any;
    user: any;
}

class BrokerActionScreen extends Component<Props, State> {
    logoInputRef: React.RefObject<HTMLInputElement>;

    constructor(props: Props) {
        super(props);
        this.logoInputRef = React.createRef();
        this.state = {
            logoObj: [],
            fileNames: {},
            loading: false,
            brokerFormData: [],
            logoPreview: null,
            logoPayload: null,
            BrokerId: '',
            user: null
        };
    }

    componentDidMount() {
        this.handleBrokerLogo();
        const token = sessionStorage.getItem('token');
        if (token) {
            const decodedToken = decodeJwt(token);
            if (decodedToken) {
                this.setState({ user: decodedToken?.UserId, BrokerId: parseInt(decodedToken?.BrokerId) });
            } else {
                console.warn("Token decoding failed or returned null");
            }
        }
        if (this.props.editData) {
            // const fullPhone = this.props.editData.vchBusiness_Phone || '';
            // const [countryCode = '', businessPhone = ''] = fullPhone?.split('-');

            // const fullPhone1 = this.props.editData.vchContact_Mobile || '';
            // const [countryCode1 = '', contactPhone = ''] = fullPhone1?.split('-');
            this.setState({
                brokerFormData: {
                    ...this.props.editData,
                    vchBusiness_Phone: this.props.editData.vchBusiness_Phone || "+91-",
                    vchContact_Mobile: this.props.editData.vchContact_Mobile || "+91-"
                }
            });
        }
    }

    handleBrokerLogo = async () => {
        const { editData } = this.props;
        this.setState({ loading: true });
        try {
            const logoForBroker = await fetchBrokerLogoById(editData?.BrokerID);
            // const logoForBroker = fetchResponse?.find((logo: any) => logo.BrokerId === editData?.BrokerID);
            const firstLogo = Array.isArray(logoForBroker) ? logoForBroker[0] : logoForBroker;
            this.setState({
                brokerFormData: {
                    ...this.state.brokerFormData,
                    vchLogo: firstLogo?.BaseString || editData?.vchLogo
                },
                logoPreview: firstLogo?.BaseString || null
            });
            console.log(this.state)
        } catch (error) {
            console.error('Error fetching data for brokerid:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === 'vchData' || name === 'vchDoc' || name === 'vchChkOutput') {
            if (!/^\d{0,4}$/.test(value)) return;
        };

        if (name === 'decReminder') {
            if (!/^\d{0,2}$/.test(value)) return;
        };

        if (name === 'decCredit' && !/^\d*\.?\d*$/.test(value)) return;

        this.setState((prevState) => ({
            brokerFormData: {
                ...prevState.brokerFormData,
                [name === 'active' ? 'bitActive' : name]: name === 'active' ? value === 'Yes' : value
            }
        }));
    };

    handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

        if (file && !allowedTypes.includes(file.type)) {
            alert('Only PNG, JPG, JPEG files are allowed!');
            e.target.value = '';
            return;
        }

        const { name } = e.target;
        this.setState(prevState => ({
            brokerFormData: {
                ...prevState.brokerFormData,
                [name]: file
            },
            fileNames: {
                ...prevState.fileNames,
                [name]: file?.name || ''
            }
        }));
    };

    clearFile = (fieldName: string) => {
        this.setState(prev => ({
            brokerFormData: { ...prev.brokerFormData, [fieldName]: null },
            fileNames: { ...prev.fileNames, [fieldName]: '' }
        }));
    };

    handlelogoChange = (event: any) => {
        const { user, BrokerId, brokerFormData } = this.state;
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (reader.result && typeof reader.result === 'string') {
                    const base64String = reader.result.split(',')[1];

                    this.setState({
                        logoPreview: base64String,
                        logoPayload: {
                            Id: 0,
                            BrokerId: parseInt(brokerFormData?.BrokerID),
                            FileName: file?.name,
                            FileSize: file?.size,
                            CreatedBy: user,
                            IsActive: true,
                            CreatedOn: new Date().toISOString(),
                            BaseString: base64String,
                        },
                        brokerFormData: {
                            ...this.state.brokerFormData,
                            vchLogo: file?.name,
                        }
                    });
                }
            };
            reader.readAsDataURL(file);
        }
    };

    // handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const vchLogo = URL.createObjectURL(file);
    //         this.setState(prev => ({
    //             brokerFormData: {
    //                 ...prev.brokerFormData,
    //                 logo: file,
    //                 vchLogo,
    //             }
    //         }));
    //     }
    // };

    handleSaveRow = async () => {
        this.setState({ loading: true });

        const { brokerFormData, logoPayload } = this.state;
        const { editData } = this.props;

        try {
            const { countryCode = "", businessPhone = "" } = brokerFormData;
            brokerFormData.vchBusiness_Phone = `${countryCode}-${businessPhone}`;

            const saveResData = await saveDataForIntroduceBrokerForm(brokerFormData);
            if (saveResData) {
                let updatedBrokerFormData = { ...brokerFormData };
                if (logoPayload?.BaseString) {
                    await saveDataForLogoData(logoPayload);
                    updatedBrokerFormData.vchLogo = logoPayload.FileName;
                }
                this.setState({
                    brokerFormData: updatedBrokerFormData,
                    logoPayload: logoPayload,
                    logoPreview: null
                });
            }
        } catch (error) {
            console.error("Error saving broker formData:", error);
        } finally {
            this.setState({ loading: false });
            // window.location.href = "/introducebroker";
        }
    };

    handlePaymentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.value;
        const value = selected === "Invoice Based" ? "2" : "1";

        this.setState(prevState => ({
            brokerFormData: {
                ...prevState.brokerFormData,
                vchPaymentOpt: value
            }
        }));
    };

    isPrimaryContactValid = () => {
        const { brokerFormData } = this.state;

        const first = brokerFormData["vchContact_First"];
        const last = brokerFormData["vchContact_Last"];
        const email = brokerFormData["vchContact_Email"];
        const mobile = brokerFormData["vchContact_Mobile"];
        const decCredit = brokerFormData["decCredit"];
        const decReminder = brokerFormData["decReminder"];
        const vchDoc = brokerFormData["vchDoc"];
        const vchData = brokerFormData["vchData"];
        const vchChkOutput = brokerFormData["vchChkOutput"];
        const paymentOpt = brokerFormData["vchPaymentOpt"];

        const isNonEmpty = (value: any) => {
            return typeof value === "string" && value.trim() !== "";
        };

        const isMobileValid =
            typeof mobile === "string" &&
            mobile.includes("-") &&
            isNonEmpty(mobile.split("-")[1]);

        const shouldValidateCreditFields = paymentOpt !== "2";

        return (
            isNonEmpty(first) &&
            isNonEmpty(last) &&
            isNonEmpty(email) &&
            isNonEmpty(vchDoc) &&
            isNonEmpty(vchData) &&
            isNonEmpty(vchChkOutput) &&
            isMobileValid &&
            (!shouldValidateCreditFields || (isNonEmpty(decCredit) && isNonEmpty(decReminder)))
        );
    };

    renderContactSection = (title: string, prefix: string, isRequired: boolean = false) => {
        const { brokerFormData } = this.state;
        const getContactFieldName = (prefix: string, field: string) => {
            const suffix = prefix ? field.toLowerCase() : field;
            return `vchContact_${prefix}${suffix}`;
        };
        const fullMobile = brokerFormData[getContactFieldName(prefix, "Mobile")] || '';
        const [countryCode = '', mobileNumber = ''] = fullMobile.split('-');

        const textFieldStyle = {
            fontSize: '12px',
            height: 32,
            '& .MuiInputBase-root': {
                height: 32,
                fontSize: '12px',
            },
            '& .MuiInputLabel-root': {
                top: "7px", fontSize: "11px"
            },
            "& .MuiOutlinedInput-input": { padding: "10px 20px" }
        };

        const labelStyle = {
            fontSize: '13px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingRight: '8px',
            minHeight: '36px',
            whiteSpace: 'nowrap'
        };

        return (
            <>
                <Grid container spacing={2} alignItems="center" justifyContent="flex-start" sx={{ mt: 2, marginLeft: '0px' }}>
                    <Grid item xs={12}>
                        <Typography sx={{ fontWeight: 100, fontSize: 13, mt: 2, padding: '2px 0', backgroundColor: '#efefef', borderTop: '0.5px solid #ddd', borderBottom: '0.5px solid #ddd' }}>
                            <span style={{ marginLeft: '10px', fontSize: '12px' }}>{title}{isRequired && <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>*</span>}</span> </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Typography sx={labelStyle}>Name</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="First"
                            name={getContactFieldName(prefix, "First")}
                            size="small"
                            fullWidth
                            value={brokerFormData[getContactFieldName(prefix, "First")] || ''} onChange={this.handleChange}
                            sx={textFieldStyle}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Middle"
                            name={getContactFieldName(prefix, "Middle")}
                            size="small"
                            fullWidth
                            value={brokerFormData[getContactFieldName(prefix, "Middle")] || ''} onChange={this.handleChange}
                            sx={textFieldStyle}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Last"
                            name={getContactFieldName(prefix, "Last")}
                            size="small"
                            fullWidth
                            value={brokerFormData[getContactFieldName(prefix, "Last")] || ''} onChange={this.handleChange}
                            sx={textFieldStyle}
                        />
                    </Grid>

                    <Grid item xs={12} sm={2}>
                        <Typography sx={labelStyle}>Email</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Email"
                            name={getContactFieldName(prefix, "Email")}
                            size="small"
                            fullWidth
                            value={brokerFormData[getContactFieldName(prefix, "Email")] || ''} onChange={this.handleChange}
                            sx={textFieldStyle}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Typography sx={labelStyle}>Phone Number</Typography>
                    </Grid>
                    <Grid item xs={12} sm={1}>
                        <TextField
                            select
                            name="countryCode"
                            size="small"
                            fullWidth
                            value={countryCode}
                            onChange={(e) => {
                                const newCode = e.target.value;
                                const newFullMobile = `${newCode}-${mobileNumber}`;
                                this.setState(prevState => ({
                                    brokerFormData: {
                                        ...prevState.brokerFormData,
                                        [getContactFieldName(prefix, "Mobile")]: newFullMobile
                                    }
                                }));
                            }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    fontSize: '12px',
                                    height: '32px'
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '12px',
                                },
                            }}
                        >
                            <MenuItem value="+91">+91</MenuItem>
                            <MenuItem value="+001">+001</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Mobile No"
                            // name={getContactFieldName(prefix, "Mobile")}
                            size="small"
                            fullWidth
                            value={mobileNumber || ''}
                            onChange={(e) => {
                                const newMobile = e.target.value;
                                if (/^\d{0,10}$/.test(newMobile)) {
                                    const newFullMobile = `${countryCode}-${newMobile}`;
                                    this.setState(prevState => ({
                                        brokerFormData: {
                                            ...prevState.brokerFormData,
                                            [getContactFieldName(prefix, "Mobile")]: newFullMobile
                                        }
                                    }));
                                }
                            }}
                            inputProps={{
                                maxLength: 10,
                                inputMode: 'numeric',
                                pattern: '[0-9]*'
                            }}
                            sx={textFieldStyle}
                        />
                    </Grid>
                </Grid>
            </>
        );
    };

    render() {
        const { onCancel, editData } = this.props;
        const { brokerFormData, loading, logoObj, logoPayload, logoPreview } = this.state;
        const fullPhoneNo = brokerFormData?.vchBusiness_Phone || '';
        const [countryCode = '', businessPhone = ''] = fullPhoneNo?.split('-');
        const buttonflag = window.location.pathname?.includes('/add');

        const textFieldStyle = {
            fontSize: '12px',
            height: 32,
            '& .MuiInputBase-root': {
                height: 32,
                fontSize: '12px',
            },
            '& .MuiInputLabel-root': {
                fontSize: '11px',
                top: '7px'
            },
        };

        const labelStyle = {
            fontSize: '13px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingRight: '8px',
            minHeight: '36px',
            whiteSpace: 'nowrap'
        };

        const inputStyle = {
            '& .MuiInputBase-root': {
                fontSize: '12px',
                height: '32px',
            },
            '& .MuiInputLabel-root': {
                fontSize: '12px',
            },
            '& input': {
                padding: '6px 8px'
            }
        };

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <div>
                    <form>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Broker Name<span style={{ color: 'red' }}>*</span></Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    disabled
                                    name="brokerName"
                                    size="small"
                                    fullWidth
                                    value={brokerFormData.vchBroker_Name || ''}
                                    onChange={this.handleChange}
                                    sx={{
                                        ...inputStyle,
                                        backgroundColor: '#f0f0f0',
                                        input: {
                                            color: '#6e6e6e',
                                        },
                                        '& .Mui-disabled': {
                                            color: '#6e6e6e',
                                            WebkitTextFillColor: '#6e6e6e',
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Active<span style={{ color: 'red' }}>*</span></Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <RadioGroup row name="active" value={brokerFormData.bitActive ? 'Yes' : 'No'} onChange={this.handleChange}>
                                    <FormControlLabel value="Yes" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '11px', marginLeft: '-9px' }}>Yes</Typography>} />
                                    <FormControlLabel value="No" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '11px', marginLeft: '-9px' }}>No</Typography>} />
                                </RadioGroup>
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Broker Address</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    name="vchAddress"
                                    size="small"
                                    fullWidth
                                    multiline
                                    rows={2}
                                    value={brokerFormData.vchAddress || ''}
                                    onChange={this.handleChange}
                                    sx={{ ...inputStyle, '& .MuiInputBase-root': { fontSize: '12px' } }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Business Phone</Typography>
                            </Grid>
                            <Grid item xs={12} sm={1.1}>
                                <TextField
                                    select
                                    name="countryCode"
                                    size="small"
                                    fullWidth
                                    value={countryCode || ''}
                                    onChange={this.handleChange}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '12px',
                                            height: '32px'
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '12px',
                                        },
                                    }}
                                >
                                    <MenuItem value="+91">+91</MenuItem>
                                    <MenuItem value="+001">+001</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={2.9}>
                                <TextField
                                    name="businessPhone"
                                    size="small"
                                    fullWidth
                                    value={businessPhone || ''}
                                    onChange={this.handleChange}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '12px',
                                            height: '32px',
                                            width: 'auto',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '12px',
                                        },
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Consolidation Code</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    name="vchConsolidateCode"
                                    size="small"
                                    fullWidth
                                    value={brokerFormData.vchConsolidateCode || ''}
                                    onChange={this.handleChange}
                                    sx={inputStyle}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Business Email</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    name="vchBusiness_Email"
                                    size="small"
                                    fullWidth
                                    value={brokerFormData.vchBusiness_Email || ''}
                                    onChange={this.handleChange}
                                    sx={inputStyle}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}></Grid>
                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Logo</Typography>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <input
                                    type="file"
                                    accept=".png,.jpg,.jpeg,.JPG,.PNG,.JPEG"
                                    name="logo"
                                    onChange={this.handlelogoChange}
                                    ref={this.logoInputRef}
                                    style={{ display: 'none' }}
                                />

                                <Box
                                    onClick={() => this.logoInputRef.current && this.logoInputRef.current.click()}
                                    sx={{
                                        width: 70,
                                        height: 65,
                                        border: '2px solid #c9bbbba1',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        borderRadius: '5px'
                                    }}
                                >
                                 
                                    {brokerFormData.vchLogo ? (
                                        <img
                                            src={
                                                logoPreview
                  ? `data:image/png;base64,${logoPreview}`
                                                    : logoPayload?.BaseString
                                                        ? `data:image/png;base64,${logoPayload.BaseString}`
                                                        : brokerFormData?.vchLogo
                                                            ? `data:image/png;base64,${brokerFormData.vchLogo}`
                                                            : `/logos/${brokerFormData.vchLogo}`
                                            }
                                            alt="Logo Preview"
                                            onError={(e) => {
                                                const target = e.target as HTMLImageElement;
                                                target.onerror = null;
                                                target.src = "/exdionedge.jpg";
                                            }}
                                            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                                        />
                                    ) : (
                                        <img
                                            src="/noImage.png"
                                            alt="No Image"
                                            style={{ width: 40, height: 40, opacity: 0.7 }}
                                        />
                                    )}

                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                <Typography sx={labelStyle}>Specify URL</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    disabled={!buttonflag}
                                    name="vchSpecify_URL"
                                    size="small"
                                    fullWidth
                                    value={brokerFormData.vchSpecify_URL || ''}
                                    onChange={this.handleChange}
                                    sx={{
                                        ...inputStyle,
                                        backgroundColor: buttonflag ? '#fff' : '#f0f0f0',
                                        input: {
                                            color: buttonflag ? 'inherit' : '#6e6e6e',
                                            WebkitTextFillColor: buttonflag ? 'inherit' : '#6e6e6e',
                                        },
                                        '& .Mui-disabled': {
                                            WebkitTextFillColor: '#6e6e6e',
                                        }
                                    }}
                                />
                            </Grid>

                            {this.renderContactSection("Primary Contact / Admin", "", true)}
                            {this.renderContactSection("Secondary Contact", "S", false)}
                            {this.renderContactSection("Tertiary Contact", "T", false)}

                            <Divider component="li" sx={{
                                marginTop: '7px',
                                marginBottom: '7px',
                                width: '100vw',
                                borderBottom: 'thin solid rgba(0, 0, 0, 0.08)',
                                borderColor: '#d3d3d3d1',
                                '::marker': {
                                    color: 'white',
                                },
                            }} />

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 0 }}>
                                <Grid item xs={12} sm={1.6}>
                                    <Typography sx={labelStyle}>Payment Option</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4.4}>
                                    <RadioGroup row value={brokerFormData.vchPaymentOpt === "2" ? "Invoice Based" : "Prepayment"} onChange={this.handlePaymentChange}>
                                        <FormControlLabel
                                            value="Prepayment"
                                            control={<Radio size="small" />}
                                            label={<Typography fontSize={13}>Prepayment</Typography>}
                                        />
                                        <FormControlLabel
                                            value="Invoice Based"
                                            control={<Radio size="small" />}
                                            label={<Typography fontSize={13}>Invoice Based</Typography>}
                                        />
                                    </RadioGroup>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} alignItems="center">
                                {brokerFormData.vchPaymentOpt !== "2" && (
                                    <>
                                        <Grid item xs={12} sm={1.5}>
                                            <Typography sx={labelStyle}>
                                                Credit<span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                name="decCredit"
                                                size="small"
                                                fullWidth
                                                value={brokerFormData.decCredit || ''}
                                                onChange={this.handleChange}
                                                sx={textFieldStyle}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={2}>
                                            <Typography sx={labelStyle}>
                                                Reminder%<span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                name="decReminder"
                                                size="small"
                                                fullWidth
                                                value={brokerFormData.decReminder || ''}
                                                onChange={this.handleChange}
                                                inputProps={{
                                                    maxLength: 2,
                                                    inputMode: 'numeric',
                                                }}
                                                sx={textFieldStyle}
                                            />
                                        </Grid>
                                    </>
                                )}
                            </Grid>

                            <Divider component="li" sx={{
                                marginTop: '7px',
                                marginBottom: '7px',
                                width: '100vw',
                                borderBottom: 'thin solid rgba(0, 0, 0, 0.08)',
                                borderColor: '#d3d3d3d1',
                                '::marker': {
                                    color: 'white',
                                },
                            }} />

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 0 }}>
                                <Grid item xs={12} sm={2.1}>
                                    <Typography sx={labelStyle}>Archive Policy(in Days)</Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <Typography sx={labelStyle}>Documents<span style={{ color: 'red' }}>*</span></Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <TextField
                                        name="vchDoc"
                                        fullWidth
                                        size="small"
                                        value={brokerFormData.vchDoc || ''}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            maxLength: 4,
                                            inputMode: 'numeric',
                                        }}
                                        sx={textFieldStyle}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <Typography sx={labelStyle}>Loading Data<span style={{ color: 'red' }}>*</span></Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <TextField
                                        name="vchData"
                                        fullWidth
                                        size="small"
                                        value={brokerFormData.vchData || ''}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            maxLength: 4,
                                            inputMode: 'numeric',
                                        }}
                                        sx={textFieldStyle}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <Typography sx={labelStyle}>Checklist Data<span style={{ color: 'red' }}>*</span></Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <TextField
                                        name="vchChkOutput"
                                        fullWidth
                                        size="small"
                                        value={brokerFormData.vchChkOutput || ''}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            maxLength: 4,
                                            inputMode: 'numeric',
                                        }}
                                        sx={textFieldStyle}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                                <Grid item xs={12} sm={1.8}>
                                    <Typography sx={labelStyle}>Background Image</Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <Typography sx={labelStyle}>1st</Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <label htmlFor="file-upload-1">
                                        <Button variant="contained" component="span" sx={{
                                            fontSize: '11px',
                                            padding: '0px 0px',
                                            minWidth: 'initial',
                                            textTransform: 'none',
                                            backgroundColor: '#d3d3d394',
                                            borderColor: '#999',
                                            color: 'black',
                                            width: '65%',
                                            border: '1px solid black',
                                            height: '21px'
                                        }}>
                                            Choose File
                                        </Button>
                                    </label>
                                    <input
                                        id="file-upload-1"
                                        type="file"
                                        name="file1"
                                        accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG"
                                        onChange={this.handleFileChange}
                                        style={{ display: 'none' }}
                                    />

                                    {this.state.fileNames.file1 && (
                                        <Typography variant="body2" sx={{ fontSize: '10px' }}>
                                            {this.state.fileNames.file1}
                                            <IconButton size="small" onClick={() => this.clearFile('file1')}>
                                                <CloseIcon sx={{ fontSize: "13px" }} />
                                            </IconButton>
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <Typography sx={labelStyle}>2nd</Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <label htmlFor="file-upload-2">
                                        <Button variant="contained" component="span" sx={{
                                            fontSize: '11px',
                                            padding: '0px 0px',
                                            minWidth: 'initial',
                                            textTransform: 'none',
                                            backgroundColor: '#d3d3d394',
                                            borderColor: '#999',
                                            color: 'black',
                                            width: '65%',
                                            border: '1px solid black',
                                            height: '21px'
                                        }}>
                                            Choose File
                                        </Button>
                                    </label>
                                    <input
                                        id="file-upload-2"
                                        type="file"
                                        name="file2"
                                        accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG"
                                        onChange={this.handleFileChange}
                                        style={{ display: 'none' }}
                                    />

                                    {this.state.fileNames.file2 && (
                                        <Typography variant="body2" sx={{ fontSize: '10px' }}>
                                            {this.state.fileNames.file2}
                                            <IconButton size="small" onClick={() => this.clearFile('file2')}>
                                                <CloseIcon sx={{ fontSize: "13px" }} />
                                            </IconButton>
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <Typography sx={labelStyle}>3rd</Typography>
                                </Grid>
                                <Grid item xs={12} sm={1.6}>
                                    <label htmlFor="file-upload-3">
                                        <Button variant="contained" component="span" sx={{
                                            fontSize: '11px',
                                            padding: '0px 0px',
                                            minWidth: 'initial',
                                            textTransform: 'none',
                                            backgroundColor: '#d3d3d394',
                                            borderColor: '#999',
                                            color: 'black',
                                            width: '55%',
                                            border: '1px solid black',
                                            height: '21px'
                                        }}>
                                            Choose File
                                        </Button>
                                    </label>
                                    <input
                                        id="file-upload-3"
                                        type="file"
                                        name="file3"
                                        accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG"
                                        onChange={this.handleFileChange}
                                        style={{ display: 'none' }}
                                    />

                                    {this.state.fileNames.file3 && (
                                        <Typography variant="body2" sx={{ fontSize: '10px' }}>
                                            {this.state.fileNames.file3}
                                            <IconButton size="small" onClick={() => this.clearFile('file3')}>
                                                <CloseIcon sx={{ fontSize: "13px" }} />
                                            </IconButton>
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>

                            <Grid container sx={{ mt: 2 }}>
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                        <Button variant="contained" color="primary"
                                            sx={{
                                                backgroundColor: '#1e1466',
                                                fontSize: '11px',
                                                padding: '2px 12px',
                                                minWidth: 60,
                                                height: 28,
                                                textTransform: 'none'
                                            }}
                                            onClick={this.handleSaveRow}
                                            disabled={!this.isPrimaryContactValid()}
                                        >
                                            {!buttonflag ? 'Update' : 'Save'}
                                        </Button>
                                        <Button variant="contained" onClick={onCancel} sx={{
                                            backgroundColor: 'white',
                                            color: 'black',
                                            fontSize: '11px',
                                            padding: '2px 12px',
                                            minWidth: 60,
                                            border: '1px solid #8080804f',
                                            height: 28,
                                            textTransform: 'none'
                                        }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </>
        )
    }
};

export default BrokerActionScreen;
